// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1VDFt","title":"Header_title__1t288","side":"Header_side__1Kvd5"};